"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const colors_1 = require("../styles/colors");
const RadioButton = ({ selected, style }) => {
    const outerStyle = Object.assign({ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 14, height: 14, border: `2px solid ${colors_1.silver}`, borderRadius: '50%', pointerEvents: 'none' }, style.outerStyle);
    const innerStyle = Object.assign({ width: 10, height: 10, borderRadius: '50%', backgroundColor: colors_1.turquoise, pointerEvents: 'none' }, style.innerStyle);
    const containerStyle = Object.assign({ height: 24, width: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }, style.containerStyle);
    return (React.createElement("div", { style: containerStyle },
        React.createElement("div", { style: outerStyle }, selected === true ? React.createElement("div", { style: innerStyle }) : React.createElement("div", null))));
};
RadioButton.defaultProps = {
    selected: false,
    style: {
        innerStyle: {},
        outerStyle: {},
    },
};
exports.default = RadioButton;
